import React, { useState, useContext } from 'react';

export type AlertContextType = {
	alert: string;
	setAlert: (msg: string) => void;
};

export const AlertContext = React.createContext<AlertContextType | null>(null);

export const useAlertContext = (): AlertContextType => useContext(AlertContext) as AlertContextType;

export const AlertProvider: React.FC<React.ReactNode> = ({ children }) => {
	const [alert, setAlert] = useState<string>('');

	return <AlertContext.Provider value={{ alert, setAlert }}>{children}</AlertContext.Provider>;
};

export default AlertContext;
